import { useEffect } from "react";
import { ACCESS_TOKEN } from "src/constants/cookiesKeys";
import { googleLoginAsync } from "src/redux/auth/actions";
import { getCurrentUserAsync } from "src/redux/currentUser/actions";
import { useAppDispatch } from "./redux";

export const useGoogleAuth = () => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    const handleGoogleLogin = () => {
      const hash = window.location.toString().split("#")[1];
      const params = new URLSearchParams(hash);
      const token = params.get(ACCESS_TOKEN);
      if (!token) return;

      dispatch(
        googleLoginAsync({
          token,
          onSuccess: () => dispatch(getCurrentUserAsync()),
        })
      );

      window.history.replaceState({}, document.title, window.location.pathname);
    };

    handleGoogleLogin();
  }, [dispatch]);
};
